import React, { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Ii18nInterpolationObject } from "src/@types/i18next";

interface Props {
  children?: ReactNode;
  title: Ii18nInterpolationObject;
}

export const HowItWorksSidebarItem: FC<Props> = ({ title, children }) => {
  const { t } = useTranslation();

  return (
    <li>
      <div className="text-xl text-purple-base font-semibold font-monument-extended py-3 sm:p-3 w-full">
        {t(title.i18nKey)}
      </div>

      {children}
    </li>
  );
};
